import { type FC } from "react";

import * as Styled from "./EmbedSparkline.styles";

export const EmbedSparklineSkeleton: FC = () => (
  <Styled.Root>
    <Styled.Plot>
      <Styled.Placeholder />
    </Styled.Plot>
    <Styled.Axis />
  </Styled.Root>
);
